<template>
	<div class="feedA">
		<div class="xuqiuTip">
			<img src="@/assets/img/ts.png" alt="" class="icon" />
			<p>当您在平台内搜索到的资源无权限浏览和下载，或者搜索不到需要的资源时，可以尝试申请资源，由我司配属的地区辅教员为您提供专属服务</p>
		</div>
		<el-row style="padding-right: 413px">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demoRuleForm">
				<el-col :span="24">
					<el-form-item label="标题" prop="title">
						<el-input v-model="ruleForm.title" placeholder="标题限30字以内" maxlength="30"></el-input>
					</el-form-item>
					<el-form-item label="正文" prop="content">
						<div class="textBox">
							<el-input v-model="ruleForm.content" resize="none" placeholder="请输入" type="textarea" maxlength="200" :rows="8"></el-input>
							<span>{{ ruleForm.content.length }}/200</span>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<div class="regFot">
						<div class="regBtn" @click="fhBtn">取消</div>
						<div class="regBtn active" @click="subFn">确认</div>
					</div>
				</el-col>
			</el-form>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'feedA',
	data() {
		return {
			ruleForm: {
				title: '',
				content: ''
			},
			rules: {
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				content: [{ required: true, message: '请输入正文', trigger: 'blur' }]
			},
			dialogVisible: false
		};
	},
	methods: {
		subFn() {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let set = this.$loading(this.$pre);
					this.$http
						.post('api/app/yydApplyResources', {
							title: this.ruleForm.title,
							content: this.ruleForm.content
						})
						.then((res) => {
							set.close();
							if (res.code == 200) {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs.ruleForm.resetFields();
							}
						});
				}
			});
		},
		fhBtn() {
			this.$router.back();
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePictureCardPreview(file) {
			this.ruleForm.imgs = file.url;
			this.dialogVisible = true;
		}
	},
	mounted() {
		let { str } = this.$route.query;
		if (str) {
			let { title } = JSON.parse(str);
			this.ruleForm.title = title;
			// this.ruleForm.content = content
		}
	}
};
</script>
<style lang="scss" scoped>
.feedA {
	.xuqiuTip {
		height: 42px;
		margin-bottom: 23px;
		background: #fff2ea;
		display: flex;
		align-items: center;
		padding-left: 22px;
		font-size: 12px;
		color: #ff7b30;
		img {
			width: 17px;
			height: 14px;
			margin-right: 8px;
		}
	}
	.textBox {
		padding: 4px 0;
		position: relative;
		span {
			color: #ababab;
			position: absolute;
			bottom: 0;
			right: 10px;
			z-index: 9;
		}
	}
	.imgBox {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		img {
			width: 20px;
			height: 18px;
			margin-bottom: 8px;
		}
		p {
			color: #ababab;
			font-size: 12px;
			line-height: 1;
		}
	}
}
.regFot {
	display: flex;
	margin-top: 27px;
	padding-left: 102px;

	.regBtn {
		width: 88px;
		height: 40px;
		margin-right: 25px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;

		&:last-of-type {
			margin-right: 0;
		}
	}

	.active {
		background: #1d7b3a;
		color: #ffffff;
		border: 1px solid #1d7b3a;
	}
}
</style>
